import { type AgGridReact } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";
import {
  getCreatedAtValue,
  getDetailsTooltip,
  getJobIdValue,
  getSuccessfulRowsValue,
  getTotalRowsValue,
} from "./columnHelpers";
import { DetailsCellRenderer } from "./DetailsCellRenderer";
import type { BulkUploadRowData } from "./bulkUploadGraphqlDataSource";

export const columnDefs: AgGridReact.AgGridReactProps<BulkUploadRowData>["columnDefs"] = [
  {
    field: "id",
    headerName: "Job Id",
    flex: 1,
    valueGetter: getJobIdValue,
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
  },
  {
    headerName: "Successful Rows",
    flex: 1,
    valueGetter: getSuccessfulRowsValue,
  },
  {
    headerName: "Total Rows",
    flex: 1,
    valueGetter: getTotalRowsValue,
  },
  {
    field: "createdAt",
    headerName: "Created At",
    flex: 1,
    valueGetter: getCreatedAtValue,
  },
  {
    field: "createdBy",
    headerName: "Created By",
    flex: 1,
  },
  {
    headerName: "Details",
    flex: 1,
    cellRenderer: DetailsCellRenderer,
    tooltipValueGetter: getDetailsTooltip,
    cellStyle: { paddingLeft: SPACING.MEDIUM, paddingRight: SPACING.MEDIUM },
  },
];
